import { render, staticRenderFns } from "./customFourth.vue?vue&type=template&id=d47cbc4c&scoped=true&"
import script from "./customFourth.vue?vue&type=script&lang=ts&setup=true&"
export * from "./customFourth.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./customFourth.vue?vue&type=style&index=0&id=d47cbc4c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47cbc4c",
  null
  
)

export default component.exports